import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import 'ag-grid-enterprise';
import ListPageHeader from "../utilities/ListPageHeader";
import AgGridTable from "../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useMediaQuery, useTheme } from '@mui/material';

const OrderCategoryList = () => {

    const theme = useTheme();
     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const [error, setError] = useState();
    const [gridApi, setGridApi] = useState(null);
    const perPage = 10;
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const gridRef = useRef();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const navigate = useNavigate();
    const [columnDefs, setColumnDefs] = useState([
        { field: 'id', enableRowGroup: true, headerName: "Name" },
        { field: 'displayName', enableRowGroup: true }
    ]);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}`;

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findOrderCategory();
            } catch (error) {
                setError(error.message);
            }
        })
    };

    const onGridReady = useCallback((params) => {
        findOrderCategory();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'OrderCategories.xlsx',
            sheetName: 'Order Categories'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);


    const findOrderCategory = async () => {
        try {
            const list = await OAuthService.getList(url + `?sort=id,asc&size=1000`);
            let orderCategories = list.data?._embedded?.orderCategories
            orderCategories = orderCategories.map((curEl) => {
                let str = curEl._links.self.href;
                str = str.split("/")
                let id = str[str.length - 1]

                return {
                    id: id,
                    displayName: curEl.displayName,
                }
            });
            setRowData(orderCategories);
        } catch (error) {
            console.log('error', error)
            setError(error.message);
        }
    }

    const onSelectionChanged = (params) => {
      setSelectedRows(params.api.getSelectedRows());
    };

    const goToRoleEdit = useCallback(
      (data) => {
        if (data?.id !== undefined) {
          navigate("/editOrderCategory/" + data.id);
        }
      },
      [navigate],
    );
    const onRowDoubleClicked = (params) => {
      if (isMobile) return;
      goToRoleEdit(params?.data);
    };

    const onRowClicked = (params) => {
      if (!isMobile) return;
      goToRoleEdit(params?.data);
    };
    useEffect(() => {
      if (selectedRows.length > 0) {
        setDeleteDisable(false);
      } else {
        setDeleteDisable(true);
      }
    }, [selectedRows]);

    return (
      <>
        <ListPageHeader
          componentName="Order Category"
          onBtExport={onBtExport}
          handlePurge={handlePurge}
          addPageLink="/addOrderCategory"
          pageName="Order Category"
          deleteDisable={deleteDisable}
          error={error}
          successMsg={successMsg}
          snackState={snackState}
          gridRef={gridRef}
        />
        <div className="h-full">
          <AgGridTable
            columnDefs={columnDefs}
            rowData={rowData}
            onGridReady={onGridReady}
            onSelectionChanged={onSelectionChanged}
            onRowDoubleClicked={onRowDoubleClicked}
            onRowClicked={onRowClicked}
            gridRef={gridRef}
            paginationPageSize={perPage}
            cacheBlockSize={perPage}
            saveGridStateName={"orderCategoryList"}
          />
        </div>
      </>
    );
}

export default OrderCategoryList;
